"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatResponse = void 0;
const api_1 = require("./api");
const formatResponse = async (url, query, jsonToEntities) => {
    const response = await api_1.API.get({ url });
    const content = jsonToEntities ? jsonToEntities(response.content) : response.content;
    let last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
    let totalPages = Math.ceil((response.totalElements - 1) / response.size);
    if (query && query.length > 0) {
        last = response.last;
        totalPages = response.totalPages;
    }
    return {
        content,
        page: {
            first: response.first,
            last,
            totalElements: response.totalElements,
            totalPages,
            number: response.number
        }
    };
};
exports.formatResponse = formatResponse;
//# sourceMappingURL=util.js.map